import { useEffect, useState } from 'react';

import { AccessorKeyColumnDef } from '@tanstack/table-core';
import { Item } from '../../types/item.types';
import { StyledCheckBox } from '../../../../shared/styles/components/integrations.styles';
import { SubItem } from '../../types/sub-item.types';
import { useHiddenColumnState } from '../../state/column-hiding.state';

type HideCheckboxProps = {
   column: AccessorKeyColumnDef<Item> | AccessorKeyColumnDef<SubItem>;
};

export const HideCheckbox = ({ column }: HideCheckboxProps) => {
   const [checked, setChecked] = useState(false);

   const [hiddenColumns, toggleColumn] = useHiddenColumnState((state) => [state.hiddenColumns, state.toggleColumn]);

   useEffect(() => {
      setChecked(hiddenColumns[column.accessorKey] === undefined ? true : hiddenColumns[column.accessorKey]);
   }, [column.accessorKey, hiddenColumns]);

   const handleChange = () => {
      toggleColumn(column.accessorKey);
   };

   return (
      <StyledCheckBox
         key={column.accessorKey}
         checked={checked}
         onChange={handleChange}
         id={column.accessorKey}
         onClick={(event) => event.stopPropagation()}
         value={''}
      />
   );
};
